import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/classrooms`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, classroomId) {
      const response = await axios.get(`${API_URL}/classrooms/${classroomId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, classroomData) {
      const response = await axios.post(`${API_URL}/classrooms`, classroomData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { classroomId, classroomData }) {
      const response = await axios.put(`${API_URL}/classrooms/${classroomId}`, classroomData);

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, classroomId) {
      const response = await axios.delete(`${API_URL}/classrooms/${classroomId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async bulkDelete(_, classroomsIds) {
      const response = await axios.delete(`${API_URL}/classrooms/bulkDelete/${classroomsIds}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/classrooms/options`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};

export default store;
